/* eslint-disable max-len */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/no-danger */
/* eslint-disable import/no-unresolved */
import React, { useState, useRef } from 'react';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from 'framer-motion';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import BoxedContainer from './layouts/BoxedContainer';

function FreeZoneVideoSlider({ id, data }) {
  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');
  const bgImage = _.get(data, 'bgImage', {});
  const bgImageMobile = _.get(data, 'bgImageMobile', {});
  const sliderItems = _.get(data, 'sliderItems', []);

  const [swiper, setSwiper] = useState(null);
  const [prevActiveSlideIndex, setPrevActiveSlideIndex] = useState(0);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleSlideChange = () => {
    if (swiper) {
      const currentSlideIndex = swiper.realIndex;
      if (currentSlideIndex !== prevActiveSlideIndex) {
        const prevSlideVideo = document.getElementById(`video-${prevActiveSlideIndex}`);
        if (prevSlideVideo && !prevSlideVideo.paused) {
          prevSlideVideo.pause();
          setIsPlaying((prev) => !prev);
        }
      }
      setPrevActiveSlideIndex(currentSlideIndex);
    }
  };

  return (
    <section id={id} className="relative bg-[#E6E6E6] lg:bg-desertStorm overflow-x-hidden">
      {_.isEmpty(bgImage) || (
        <LazyLoadImage
          src={bgImage.url}
          alt="bg texture"
          className="absolute inset-0 object-cover object-left md:object-center h-full w-full blur-sm md:blur-none
          hidden md:block"
        />
      )}
      {_.isEmpty(bgImageMobile) || (
        <LazyLoadImage
          src={bgImageMobile.url}
          alt="bg texture"
          className="absolute inset-0 object-cover object-left md:object-center h-full w-full blur-sm md:blur-none
          md:hidden"
        />
      )}
      <div className="py-12.5 lg:py-25 w-full flex flex-col gap-7 lg:gap-15">
        <BoxedContainer className="lg:!max-w-[100vw] lg:!px-18.75 flex flex-col gap-10 lg:gap-20">
          <div className="w-full grid grid-cols-6 lg:grid-cols-12 gap-10 lg:gap-20">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.4 }}
              viewport={{ once: true }}
              className="col-span-6 lg:col-span-12 flex flex-col items-center gap-5">
              <div
                className="child:text-clamp20to40 child:ltr:!font-URWDINRegular child:rtl:!font-GESSTwoDWTCMedium child:leading-[1.3]
                last:child:!m-0 child:text-center child:text-[#231F20] "
                dangerouslySetInnerHTML={{ __html: title }}
              />
              <div className="py-px bg-red w-10 lg:w-12.5" />
              <div
                className="child:text-clamp12to18 child:ltr:!font-URWDINRegular child:rtl:!font-GESSTwoDWTCLight child:leading-1.4
                last:child:!m-0 child:text-center col-span-6 child:text-[#4D4D4D]"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </motion.div>
          </div>
        </BoxedContainer>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.5 }}
          viewport={{ once: true }}
          className="w-full relative">
          <Swiper
            draggable
            pagination={{ clickable: true }}
            modules={[Pagination, Navigation]}
            breakpoints={{
              340: {
                spaceBetween: 28,
              },
              1024: {
                spaceBetween: 30,
              },
            }}
            loop
            centeredSlides
            slidesPerView="auto"
            className="swiper-slide-active:!opacity-100 swiper-slide:opacity-0 swiper-slide:md:opacity-50 pb-10 
            swiper-pagination:!bottom-[0] swiper-pagination:md:hidden 
            swiper-pagination-bullet:bg-transparent swiper-pagination-bullet:w-2
            swiper-pagination-bullet:h-2 swiper-pagination-bullet:opacity-100
            swiper-pagination-bullet:border swiper-pagination-bullet:border-[#333]
            swiper-pagination-bullet:rounded-full swiper-pagination-bullet-active:!bg-red
            swiper-pagination-bullet-active:!border-red !overflow-visible md:!overflow-hidden"
            navigation={{
              prevEl: '.prev',
              nextEl: '.next',
            }}
            onSlideChange={handleSlideChange} // Call handleSlideChange on slide change
            onSwiper={setSwiper} // Store the Swiper instance
          >
            {_.map(sliderItems, (item, key) => {
              const videoUrl = _.get(item, 'content.videoUrl', null);
              const personName = _.get(item, 'content.personName', '');
              const position = _.get(item, 'content.position', '');
              const quote = _.get(item, 'content.quote', '');
              const videoRef = useRef(null);

              const handleTogglePlayback = () => {
                if (videoRef.current.paused) {
                  videoRef.current.play();
                } else {
                  videoRef.current.pause();
                }
                setIsPlaying((prev) => !prev);
              };

              const handleMouseLeave = () => {
                setIsMouseOver(false);
              };

              const handleMouseEnter = () => {
                setIsMouseOver(true);
              };

              return (
                <SwiperSlide
                  key={key}
                  className="max-w-[calc(100%-40px)] md:max-w-[calc(100%-30px)] 
                lg:max-w-[970px] w-full bg-white transition-opacity">
                  {videoUrl && (
                    <div
                      className="w-full md:h-[420px] z-10 relative overflow-hidden"
                      onMouseLeave={handleMouseLeave}
                      onMouseEnter={handleMouseEnter}>
                      {videoUrl.includes('.mp4') ? (
                        <>
                          <video
                            className="w-full h-full aspect-video object-cover pointer-events-none"
                            ref={videoRef}
                            id={`video-${key}`}>
                            <source src={videoUrl} type="video/mp4" />
                          </video>
                          <button
                            type="button"
                            onClick={handleTogglePlayback}
                            className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-0 bg-white z-20 
                            w-[50px] h-[50px] md:w-[75px] md:h-[75px] 2l:w-[100px] 2l:h-[100px] rounded-full transition-opacity duration-300
                            ${isPlaying ? (isMouseOver ? 'opacity-100' : 'opacity-0') : ''} `}>
                            {isPlaying ? (
                              <svg
                                viewBox="0 0 100 100"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="50" cy="50" r="50" fill="#CE445B" />
                                <path
                                  d="M58.8229 34.0001H51.7658C51.5038 34.0001 51.2915 34.2124 51.2915 34.4744V65.5258C51.2915 65.7877 51.5038 66 51.7658 66H58.8229C59.0849 66 59.2971 65.7877 59.2971 65.5258V34.4744C59.2971 34.2124 59.0849 34.0001 58.8229 34.0001Z"
                                  fill="white"
                                />
                                <path
                                  d="M47.5314 34H40.4742C40.2123 34 40 34.2123 40 34.4742V65.5256C40 65.7876 40.2123 65.9999 40.4742 65.9999H47.5314C47.7933 65.9999 48.0056 65.7876 48.0056 65.5256V34.4742C48.0056 34.2123 47.7933 34 47.5314 34Z"
                                  fill="white"
                                />
                              </svg>
                            ) : (
                              <svg

                                viewBox="0 0 100 100"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="50" cy="50" r="50" fill="#CE445B" />
                                <path
                                  d="M39.8571 65C39.7093 65 39.5614 64.9619 39.4286 64.8851C39.1633 64.7321 39 64.4489 39 64.1429L39.0009 35.857C39.0009 35.551 39.1641 35.2678 39.4294 35.1148C39.6947 34.9617 40.0213 34.9617 40.2866 35.1148L64.783 49.2577C65.0482 49.4107 65.2115 49.6939 65.2115 49.9999C65.2115 50.3059 65.0482 50.5892 64.783 50.7422L40.2857 64.8851C40.1529 64.9619 40.005 65 39.8571 65Z"
                                  fill="white"
                                />
                              </svg>
                            )}
                          </button>
                        </>
                      ) : (
                        <iframe
                          src={videoUrl}
                          title="about intro video"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope;
                          picture-in-picture"
                          webkitallowfullscreen="true"
                          mozallowfullscreen="true"
                          allowFullScreen
                          className="w-full min-w-full min-h-full object-cover aspect-video
                          lg:absolute lg:top-1/2 lg:left-1/2
                          lg:-translate-x-1/2 lg:-translate-y-1/2"
                        />
                      )}
                    </div>
                  )}
                  <div className="flex flex-col px-3 py-3.5 lg:p-12">
                    <p className="text-clamp10to18 text-liver ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight mb-[15px] md:mb-[30px]">{quote}</p>
                    <div className="flex flex-col lg:flex-row gap-[3px] lg:gap-4 lg:items-center">
                      <span className="text-clamp12to20 text-red font-DINMedium">
                        {personName}
                      </span>
                      <span className="text-clamp10to16 text-darkGray font-DINRegular">
                        {position}
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className="hidden lg:block absolute top-[140px] lg:top-[180px] z-50 left-0 right-0 pointer-events-none">
            <div className="pointer-events-none max-w-[calc(100%-40px)] md:max-w-[calc(100%-30px)] lg:max-w-[1030px] w-full mx-auto flex justify-between">
              <button type="button" className="prev pointer-events-auto">
                <svg
                  className="w-[40px] lg:w-[64px] h-[40px] lg:h-[64px] rtl:scale-[-1]"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="32" cy="32" r="32" transform="matrix(-1 0 0 1 64 0)" fill="white" />
                  <path
                    d="M36 44L24 32L36 20"
                    stroke="#333333"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <button type="button" className="next pointer-events-auto">
                <svg
                  viewBox="0 0 64 64"
                  className="w-[40px] lg:w-[64px] h-[40px] lg:h-[64px] rtl:scale-[-1]"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32Z"
                    fill="white"
                  />
                  <path
                    d="M28 44L40 32L28 20"
                    stroke="#333333"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default FreeZoneVideoSlider;
